import React from 'react';
import SeoHead from '../components/SeoHead';
import { TfiMicrosoftAlt } from "react-icons/tfi";
import { CiBoxList } from "react-icons/ci";
import { IoIosGitCompare } from "react-icons/io";
import { IoIosPerson } from "react-icons/io";
import { MdOutlineRateReview } from "react-icons/md";
import { FaMicrosoft } from "react-icons/fa";
import { BsDatabaseFillGear } from "react-icons/bs";
import { GrDocumentWord } from "react-icons/gr";
import sharepointImg from '../assets/sharepoint.png';
import chatUdbudImg from '../assets/chat_udbudsagent.png';
import konditionsImg from '../assets/konditionsmessig.png';
import kvalitetsImg from '../assets/kvalitetsmessig.png';

const pageStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #fff7f4 0%, #ffffff 60%, #fef1eb 100%)',
  color: '#1f1f1f',
  fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
};

const sectionStyle = {
  maxWidth: '85%',
  margin: '0 auto',
  padding: '4rem 1.5rem',
};

const heroSectionStyle = {
  width: '100%',
  padding: '4rem 0',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const heroInnerStyle = {
  maxWidth: '85%',
  margin: '0 auto',
  padding: '0 1.5rem',
  display: 'flex',
  justifyContent: 'center',
};

const heroStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '1.5rem',
};

const badgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  padding: '0.4rem 0.9rem',
  borderRadius: '999px',
  background: '#FFF0EC',
  color: '#C03626',
  fontWeight: 700,
  fontSize: '0.9rem',
};

const heroTitleStyle = {
  display: 'flex',
  justifyContent: 'center',
  fontSize: '2.8rem',
  lineHeight: 1.15,
  margin: '1rem 0 1.25rem',
  color: '#1f1f1f',
  fontWeight: 800,
};

const heroTextStyle = {
  fontSize: '1.15rem',
  lineHeight: 1.7,
  color: '#353535',
  maxWidth: '36rem',
};

const ctaRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  marginTop: '1.75rem',
  justifyContent: 'center',
};

const primaryCtaStyle = {
  background: 'linear-gradient(135deg, #C03626, #FF6F61)',
  color: '#ffffff',
  border: 'none',
  borderRadius: '12px',
  padding: '1rem 1.6rem',
  fontWeight: 700,
  fontSize: '1rem',
  cursor: 'pointer',
  boxShadow: '0 14px 30px rgba(192, 54, 38, 0.25)',
};

const secondaryCtaStyle = {
  background: '#ffffff',
  color: '#C03626',
  border: '1px solid #C03626',
  borderRadius: '12px',
  padding: '1rem 1.6rem',
  fontWeight: 700,
  fontSize: '1rem',
  cursor: 'pointer',
};

const placeholderFrame = {
  width: '100%',
  minHeight: '300px',
  background: '#ffffff',
  borderRadius: '18px',
  border: '1px dashed transparent',
  display: 'grid',
  placeItems: 'center',
  color: '#9c2c1f',
  fontWeight: 700,
  fontSize: '1rem',
};

const sectionHeaderStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.4rem',
  marginBottom: '1.5rem',
};

const eyebrowStyle = {
  textTransform: 'uppercase',
  letterSpacing: '0.18em',
  fontWeight: 700,
  color: '#C03626',
  fontSize: '0.85rem',
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  gap: '1.75rem',
};

const flowSectionStyle = {
  width: '90%',
  marginLeft: '1.5rem'
};

const flowHeaderStyle = {
  textAlign: 'center',
  marginBottom: '2rem',
};

const flowRowStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  gap: '0.2rem',
  alignItems: 'stretch',
  width: '100%',
  padding: '0 1.5rem',
};

const flowCardStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.65rem',
  minHeight: '100%',
  width: '85%',
};

const flowImageStyle = {
  width: '90%',
  objectFit: 'contain',
  padding: '0.75rem',
  borderRadius: '6px',
  boxShadow: '0 10px 24px rgba(0,0,0,0.2)',
};

const flowTitleStyle = {
  fontWeight: 800,
  fontSize: '1.05rem',
  color: '#1f1f1f',
  marginLeft: '1rem',
  marginTop: '0.5rem',
};

const flowTitleStyleAutomatiskLeveranse = {
  fontWeight: 800,
  fontSize: '1.05rem',
  color: '#1f1f1f',
  marginLeft: '1rem',
  marginTop: '5rem',
};

const flowTextStyle = {
  fontSize: '0.98rem',
  lineHeight: 1.55,
  color: '#373737',
  marginLeft: '1rem',
  maxWidth: '90%',
};

const flowArrow = {
  display: 'grid',
  placeItems: 'center',
  fontSize: '1.6rem',
  fontWeight: 800,
  color: '#C03626',
};

const outputGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: '1rem',
};

const problemRowStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '2rem',
  alignItems: 'flex-start',
  background: '#fff',
  borderRadius: '18px',
  padding: '2rem',
  border: '1px solid #f1d1c9',
  boxShadow: '0 14px 34px rgba(0, 0, 0, 0.04)',
};

const problemLeftStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
};

const problemRightStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  gap: '0.65rem 1.2rem',
};

const checklistItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.6rem',
  fontSize: '1rem',
  lineHeight: 1.5,
  color: '#2d1f1b',
};

const checkIconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  background: '#FFF0EC',
  color: '#C03626',
  fontWeight: 800,
  fontSize: '0.95rem',
  marginTop: '0.1rem',
};

const overlapWrapStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '620px',
  margin: '0 auto 1.8rem',
  paddingBottom: '18%',
};

const deliverableBaseImgStyle = {
  ...flowImageStyle,
  position: 'relative',
  width: '75%',
  maxWidth: '480px',
  zIndex: 1,
};

const deliverableTopImgStyle = {
  ...flowImageStyle,
  position: 'absolute',
  bottom: '-16%',
  right: '-10%',
  width: '78%',
  maxWidth: '430px',
  zIndex: 2,
  transform: 'rotate(-1.5deg)',
  boxShadow: '0 16px 38px rgba(0,0,0,0.25)',
};

const flowResponsiveCss = `
  @media (max-width: 900px) {
    .ua-flow-row { grid-template-columns: 1fr !important; gap: 1.4rem; }
    .ua-flow-card { width: 100% !important; padding-bottom: 5rem !important; }
    .ua-overlap { width: 90% !important; margin: 0 auto 1.6rem !important; padding-bottom: 14% !important; }
    .ua-overlap .ua-base-img { width: 85% !important; max-width: none; }
    .ua-overlap .ua-top-img { width: 82% !important; right: -2% !important; bottom: -12% !important; max-width: none; }
  }
`;

const flowDebugColors = ['#ffe5e5', '#e5ffe7', '#e7f0ff'];

const cardStyle = {
  background: '#ffffff',
  borderRadius: '14px',
  padding: '1.4rem',
  border: '1px solid #f1d1c9',
  boxShadow: '0 14px 34px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};

const iconDotStyle = {
  width: '46px',
  height: '46px',
  borderRadius: '12px',
  background: '#FFF0EC',
  display: 'grid',
  placeItems: 'center',
  color: '#C03626',
  fontWeight: 800,
  fontSize: '1.3rem',
};

const footerStripStyle = {
  marginTop: '3rem',
  padding: '1.5rem 1.4rem',
  borderRadius: '12px',
  border: '1px solid #f1d1c9',
  background: '#fff9f6',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const featuresData = [
  {
    title: "Automatisk kravudtræk",
    desc: "Spar timevis og få konsistente krav uden fejl.",
    Icon: CiBoxList,
  },
  {
    title: "Sammenligning af tilbud",
    desc: "Se straks hvilke leverandører der opfylder hvilke krav.",
    Icon: IoIosGitCompare,
  },
  {
    title: "Objektiv evaluering",
    desc: "Struktur der reducerer bias og sikrer fairness.",
    Icon: MdOutlineRateReview,
  },
  {
    title: "Integreret i Microsoft 365",
    desc: "Ingen nye systemer. Ingen datatransport. Minimal IT-belastning.",
    Icon: FaMicrosoft,
  },
  {
    title: "Automatiske rapporter",
    desc: "Modtag professionel compliance- og scoringsdokumentation automatisk.",
    Icon: BsDatabaseFillGear,
  },
  {
    title: "Rediger direkte i Word",
    desc: "Eksportér analyser til Word og tilpas dem med jeres eget layout.",
    Icon: GrDocumentWord,
  },
  {
    title: "Menneskelig ekspertise først",
    desc: "Agenten erstatter ikke jeres faglige dømmekraft – den gør det hurtigere og lettere at træffe de rigtige valg.",
    Icon: IoIosPerson,
  },
];

const Udbudsagent = () => {
  return (
    <div style={pageStyle}>
      <SeoHead
        title="Udbudsagenten | AI til udbud og tilbud"
        description="Udbudsagenten strukturerer udbud, finder relevante krav og hjælper teamet med udkast, kvalitetstjek og sporbarhed i tilbudsprocessen."
        canonicalPath="/losninger/udbudsagent"
      />
      <style>{flowResponsiveCss}</style>

      {/* ---------------- HERO SECTION ---------------- */}
      <section style={heroSectionStyle}>
        <div style={heroInnerStyle}>
          <div style={heroStyle}>
            <div>
              <div style={badgeStyle}>🚀 AI til udbud & procurement</div>

              <h1 style={heroTitleStyle}>
                Automatisér evalueringer.<br />
                Lever bedre beslutninger.<br />
                Spar værdifuld tid.
              </h1>

              <p style={heroTextStyle}>
                Udbudsagenten hjælper teams med at analysere udbud og tilbud hurtigere og mere ensartet.
                Få strukturerede krav, automatiske sammenligninger og gennemsigtig dokumentation.
              </p>

              <div style={{ marginTop: '1.5rem', display: 'inline-flex', alignItems: 'center', gap: 8, color: '#2D1F1B', fontWeight: 600 }}>
                <TfiMicrosoftAlt size={20} color="#C03626" />
                <span>Implementeret i jeres Microsoft-miljø</span>
              </div>

              <div style={ctaRowStyle}>
                <button type="button" style={primaryCtaStyle}>Book en demo</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- PROBLEM SECTION ---------------- */}
      <section style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <span style={eyebrowStyle}>Problemet</span>
          <h2 style={{ fontSize: '2.1rem', margin: 0 }}>Udbud og tilbud tager alt for lang tid at gennemgå.</h2>
        </div>

        <div style={problemRowStyle}>
          <div style={problemLeftStyle}>
            <h3 style={{ margin: 0, fontSize: '1.6rem', lineHeight: 1.3, color: '#1f1f1f' }}>
              Skab klarhed, tempo og ensartethed i evalueringerne
            </h3>
            <p style={{ margin: '0.75rem 0 0', fontSize: '1.05rem', lineHeight: 1.65, color: '#3b2f2b' }}>
              Saml udbudsmateriale, krav og vurderinger ét sted. Udbudsagenten hjælper jer med at standardisere
              processen, så teams kan levere hurtigere og mere transparent uden at gå på kompromis med kvaliteten.
            </p>
          </div>

          <div style={problemRightStyle}>
            {[
              "Test og gennemgå materialet direkte fra SharePoint",
              "Få et ensartet vurderingsgrundlag på tværs af teamet",
              "Reducer bias med klare, dokumenterede scoringskriterier",
              "Spar tid på manuelle sammenligninger og udtræk",
              "Hold dokumentation klar til revision og compliance",
              "Lever bedre beslutninger uden at misse deadlines",
            ].map((text, idx) => (
              <div key={idx} style={checklistItemStyle}>
                <span style={checkIconStyle}>✓</span>
                <span>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- FLOW SECTION ---------------- */}
      <section style={flowSectionStyle}>
        <div style={flowHeaderStyle}>
          <span style={eyebrowStyle}>Fra filer til leverancer</span>
          <h2 style={{ fontSize: '2rem', margin: '0.35rem 0 0.5rem' }}>Sådan arbejder udbudsagenten</h2>
          <p style={{ fontSize: '1.05rem', color: '#404040', margin: 0 }}>
            Upload udbudsdokumenter, chat med agenten og få klar output: konditionsmæssig og kvalitetsmæssig analyse.
          </p>
        </div>

        <div style={flowRowStyle} className="ua-flow-row">
          <div style={flowCardStyle} className="ua-flow-card">
            <img src={sharepointImg} alt="SharePoint uploads" style={flowImageStyle} />
            <div style={flowTitleStyle}>Upload til SharePoint</div>
            <div style={flowTextStyle}>Henter udbudsmateriale direkte fra jeres SharePoint. Agenten læser indholdet og forbereder analysen.</div>
          </div>
          <div style={flowCardStyle} className="ua-flow-card">
            <img src={chatUdbudImg} alt="Chat med udbudsagent" style={flowImageStyle} />
            <div style={flowTitleStyle}>Chat & afklaringer</div>
            <div style={flowTextStyle}>Stil spørgsmål, få uddrag, sammenlign krav og få guidance, mens agenten arbejder på materialet.</div>
          </div>
          <div style={flowCardStyle} className="ua-flow-card">
            <div style={overlapWrapStyle} className="ua-overlap">
              <img
                src={konditionsImg}
                alt="Konditionsmæssig analyse"
                style={deliverableBaseImgStyle}
                className="ua-base-img"
              />
              <img
                src={kvalitetsImg}
                alt="Kvalitetsmæssig analyse"
                style={deliverableTopImgStyle}
                className="ua-top-img"
              />
            </div>
            <div style={flowTitleStyleAutomatiskLeveranse}>Automatiske leverancer</div>
            <div style={outputGridStyle}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', maxWidth: '40%' }}>
                <div style={flowTextStyle}><strong>Konditionsmæssig analyse</strong><br /> Formelle krav og compliance samlet.</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', maxWidth: '40%' }}>
                <div style={flowTextStyle}><strong>Kvalitetsmæssig analyse</strong><br /> Vurdering af indhold, kvalitet og forbedringspunkter.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- FEATURES ---------------- */}
      <section style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <span style={eyebrowStyle}>Features</span>
          <h2 style={{ fontSize: '2rem', margin: 0 }}>Kraftfulde funktioner til moderne udbud & indkøb.</h2>
        </div>

        <div style={gridStyle}>
          {featuresData.map(({ title, desc, Icon }) => (
            <div key={title} style={cardStyle}>
              <div style={iconDotStyle}>
                <Icon size={22} />
              </div>
              <h3 style={{ margin: 0 }}>{title}</h3>
              <p style={{ margin: 0, lineHeight: 1.6 }}>{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- VIDEO PLACEHOLDER (temporarily hidden) ----------------
      <section style={{ ...sectionStyle, paddingBottom: '6rem' }}>
        <div style={sectionHeaderStyle}>
          <span style={eyebrowStyle}>Demo video</span>
          <h2 style={{ fontSize: '2rem', margin: 0 }}>Se løsningen i aktion</h2>
        </div>
        <div
          style={{
            position: 'relative',
            width: '100%',
            maxWidth: '960px',
            margin: '0 auto',
            paddingTop: '56.25%', // 16:9 ratio
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #FFF0EC, #FFE4DC)',
            border: '1px solid #f1d1c9',
            boxShadow: '0 18px 40px rgba(0,0,0,0.08)',
            overflow: 'hidden',
            display: 'block',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: '0',
              display: 'grid',
              placeItems: 'center',
              color: '#C03626',
              fontWeight: 700,
              fontSize: '1.05rem',
              gap: '0.5rem',
            }}
          >
            <div style={{ fontSize: '1.8rem' }}>▶</div>
            <div>Video placeholder – upload demo her</div>
          </div>
        </div>
      </section>
      */}

    </div>
  );
};

export default Udbudsagent;
